import React, { useState } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { apiFetch } from '../lib/api';
import { useAuth } from '../context/AuthContext';

// Serves both invite acceptance (/accept) and reset (/reset).
export default function SetPassword() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const kind = location.pathname.startsWith('/accept') ? 'invite' : 'reset';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit() {
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setBusy(true);
    try {
      const res = await apiFetch('/api/auth/set-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, kind, password }),
      });
      if (!res.ok) { setError('This link is invalid or has expired.'); return; }
      const data = await res.json();
      login(data.token, data.user);
      navigate('/');
    } catch (e) {
      setError('Could not reach the server. Try again.');
    } finally { setBusy(false); }
  }

  return (
    <div className="page-content" style={{ maxWidth: 360, margin: '64px auto', padding: 24 }}>
      <h1>{kind === 'invite' ? 'Set your password' : 'Reset password'}</h1>
      {!token && <p style={{ color: '#dc2626' }}>Missing token.</p>}
      <input placeholder="New password" type="password" value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ display: 'block', width: '100%', margin: '8px 0', padding: 8 }} />
      <input placeholder="Confirm password" type="password" value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        style={{ display: 'block', width: '100%', margin: '8px 0', padding: 8 }} />
      {error && <p style={{ color: '#dc2626' }}>{error}</p>}
      <button onClick={handleSubmit} disabled={busy || !token} style={{ width: '100%', padding: 10 }}>
        {busy ? 'Saving…' : 'Save password'}
      </button>
    </div>
  );
}
